<template>
  <div class="manual-container">
    <ManualLeftSideBar :loadManual="load" :subPath="subPath" />
    <main class="manual-content"ref="manualContent">
      <div v-html="html" />
    </main>
    <ManualRightSideBar :loadManual="load" :subPath="subPath" />
  </div>
</template>

<script>
import { renderMarkdown } from "@/utils/markdown";
import ManualLeftSideBar from "@/components/manual/ManualLeftSideBar.vue";
import ManualRightSideBar from "@/components/manual/ManualRightSideBar.vue";
import mermaid from "mermaid/dist/mermaid.esm.mjs";

export default {
  name: "Manual",
  components: { ManualLeftSideBar, ManualRightSideBar },
  data() {
    return {
      html: "",
      headings: [],
    };
  },
  mounted() {
    mermaid.initialize({
      startOnLoad: false,
      theme: "default",
    });
  },
  methods: {
    async load(section) {
      const raw = await import(
        `@/assets/docs/ca2-user-manual/${section}.md?raw`
      );
      this.html = renderMarkdown(raw.default);

      this.$nextTick(() => {
        const id = this.subPath.replace("#", "");
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "auto", block: "start" });
        }
        this.renderMermaid();
      });
    },
    renderMermaid() {
      const blocks = this.$el.querySelectorAll(".mermaid");

      blocks.forEach((element, i) => {
        try {
          element.innerHTML = element.textContent.trim();
          const id = `m-${i}`;
          this.$nextTick(() => {
            mermaid.init(id, element);
          });
        } catch (err) {
          console.error("Mermaid render failed:", err);
          element.innerHTML = `<pre class="mermaid-error">${element.textContent}</pre>`;
        }
      });
    },
  },
  computed: {
    subPath() {
      return this.$route.hash || "#1";
    },
  },
};
</script>

<style lang="scss">
.manual-container {
  display: flex;
  flex-direction: row;
  background-color: $surface-gamma;
  max-height: 740px;
}

.manual-content {
  flex: 1;
  padding-left: 10px;
  padding-right: 10px;
  padding: 1.3rem;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: $surface-beta;
  border-right: 1px solid #00000040;
  max-height: 90vh;

}

.manual-content h1 {
  font-size: 38px;
  font-weight: 400;
  color: $primary;
  padding: 0 10px;
  margin: 10px 0;
}

.manual-content p {
  font-size: 14px;
  padding: 0 10px;
  margin-bottom: 15px;
}
.manual-content h2,
h3 {
  margin: 15px 0;
  color: $primary;
  padding: 0 10px;
}

.manual-content h2 {
  font-weight: 400;
  font-size: 28px;
}

.manual-content h3 {
  font-weight: 400;
  font-size: 22px;
}
.manual-content h4 {
  padding: 0 10px;
}

.manual-content thead th {
  text-align: start;
  padding-left: 1rem;
}
.manual-content tbody td {
  font-size: 14px;
  padding-left: 1rem;
  min-width: 2rem;
}

.manual-content ul {
  display: flex;
  flex-direction: column;
  list-style-type: disc;
}

.manual-content ul li {
  display: list-item;
  margin-left: 50px;
}

.manual-content ol {
  display: flex;
  flex-direction: column;
  list-style-type: decimal;
}

.manual-content ol li {
  display: list-item;
}

.manual-content p img {
  display: flex;
  flex-direction: column;
  justify-self: center;
  margin: 1rem 0;
  max-width: 700px;
}
</style>
